import React from 'react';
import DocumentReader from './DocumentReader';
import { documentTitle, documentSlug, parts } from './content/psdaReference';

export default function PsdaReference() {
  return (
    <DocumentReader
      documentId={documentSlug}
      title={documentTitle}
      intro="Quick-lookup formulas and rules for Problem-Solving and Data Analysis — ratios and units, percent change, center and spread, correlation, probability, and study design."
      parts={parts}
    />
  );
}
